// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apercu read-only de l'affectation (modale annuaire) : toolbar (lot + filtre) + infos + carte. */
.affectation-apercu {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.affectation-apercu-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  flex-wrap: wrap;
}
.affectation-apercu-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.affectation-apercu-field span {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}
.affectation-apercu-field select {
  min-width: 24rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  cursor: pointer;
}
.affectation-apercu-field select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

/* Carte centree et bornee (meme taille que la gestion d'equipe). */
.affectation-apercu-mapcard {
  display: flex;
  justify-content: center;
  padding: 1.4rem;
  background: #fafbfc;
  border: 1px solid #eef0f2;
  border-radius: 1rem;
}
.affectation-apercu-mapcard .carte-affectation {
  width: 100%;
  max-width: 420px;
}

/* Infos des interlocuteurs : grille 4 colonnes (2 sur ecran etroit) ; survol -> surligne la carte. */
.affectation-apercu-interlos {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem 0.8rem;
}
@media (max-width: 1100px) {
  .affectation-apercu-interlos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.affectation-apercu-interlo {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.6rem 0.7rem;
  border-radius: 0.6rem;
  cursor: default;
  transition: background 0.12s ease;
}
.affectation-apercu-interlo:hover {
  background: #f9fafb;
}
.affectation-apercu-interlo-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}
.affectation-apercu-interlo-nom {
  font-size: 1.25rem;
  font-weight: 700;
  color: #374151;
  overflow-wrap: anywhere;
}
.affectation-apercu-interlo-contact {
  font-size: 1.1rem;
  color: #6b7280;
  overflow-wrap: anywhere;
}
.affectation-apercu-pastille {
  flex-shrink: 0;
  width: 1.4rem;
  height: 1.4rem;
  margin-top: 0.2rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/composants/AffectationCarte/AffectationApercu.css"],"names":[],"mappings":"AAAA,kGAAkG;AAClG;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qGAAqG;AACrG;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;AACvC","sourcesContent":["/* Apercu read-only de l'affectation (modale annuaire) : toolbar (lot + filtre) + infos + carte. */\n.affectation-apercu {\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n}\n\n.affectation-apercu-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n}\n.affectation-apercu-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.affectation-apercu-field span {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #595959;\n}\n.affectation-apercu-field select {\n  min-width: 24rem;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  cursor: pointer;\n}\n.affectation-apercu-field select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n/* Carte centree et bornee (meme taille que la gestion d'equipe). */\n.affectation-apercu-mapcard {\n  display: flex;\n  justify-content: center;\n  padding: 1.4rem;\n  background: #fafbfc;\n  border: 1px solid #eef0f2;\n  border-radius: 1rem;\n}\n.affectation-apercu-mapcard .carte-affectation {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* Infos des interlocuteurs : grille 4 colonnes (2 sur ecran etroit) ; survol -> surligne la carte. */\n.affectation-apercu-interlos {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.5rem 0.8rem;\n}\n@media (max-width: 1100px) {\n  .affectation-apercu-interlos {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.affectation-apercu-interlo {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding: 0.6rem 0.7rem;\n  border-radius: 0.6rem;\n  cursor: default;\n  transition: background 0.12s ease;\n}\n.affectation-apercu-interlo:hover {\n  background: #f9fafb;\n}\n.affectation-apercu-interlo-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n.affectation-apercu-interlo-nom {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #374151;\n  overflow-wrap: anywhere;\n}\n.affectation-apercu-interlo-contact {\n  font-size: 1.1rem;\n  color: #6b7280;\n  overflow-wrap: anywhere;\n}\n.affectation-apercu-pastille {\n  flex-shrink: 0;\n  width: 1.4rem;\n  height: 1.4rem;\n  margin-top: 0.2rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
